import { useEffect, useState } from 'react';
import {
  GOOD_HALF_WIDTH,
  PERFECT_HALF_WIDTH,
  POWER_OVERHIT,
  accuracyFromNeedle,
  needleAt,
  powerAt,
} from '../game/meters.js';
import { useNow } from './useNow.js';

interface Props {
  kind: 'power' | 'accuracy';
  onStop: (value: number) => void;
}

/** Индикатор силы или точности: бегунок движется, тап по кнопке — остановить. */
export function Meter({ kind, onStop }: Props) {
  // Отсчёт — с первого кадра после показа индикатора
  const [start, setStart] = useState<number | null>(null);
  useEffect(() => {
    const id = requestAnimationFrame(() => setStart(performance.now()));
    return () => cancelAnimationFrame(id);
  }, [kind]);
  const now = useNow();
  const t = start === null ? 0 : Math.max(0, now - start);
  const pos = kind === 'power' ? powerAt(t) : needleAt(t);

  const stop = () => {
    const elapsed = start === null ? 0 : performance.now() - start;
    onStop(kind === 'power' ? powerAt(elapsed) : accuracyFromNeedle(needleAt(elapsed)));
  };

  return (
    <button
      type="button"
      className={`meter meter--${kind}`}
      onClick={stop}
      aria-label={kind === 'power' ? 'Остановить силу' : 'Остановить точность'}
    >
      <span className="meter__title">{kind === 'power' ? 'Сила — тапни!' : 'Точность — тапни в центр!'}</span>
      <span className="meter__track">
        {kind === 'power' ? (
          <>
            <span className="meter__fill" style={{ width: `${pos * 100}%` }} />
            <span className="meter__overhit" style={{ left: `${POWER_OVERHIT * 100}%` }} />
          </>
        ) : (
          <>
            <span
              className="meter__good"
              style={{ left: `${(0.5 - GOOD_HALF_WIDTH) * 100}%`, width: `${GOOD_HALF_WIDTH * 200}%` }}
            />
            <span
              className="meter__perfect"
              style={{ left: `${(0.5 - PERFECT_HALF_WIDTH) * 100}%`, width: `${PERFECT_HALF_WIDTH * 200}%` }}
            />
            <span className="meter__needle" style={{ left: `${pos * 100}%` }} />
          </>
        )}
      </span>
    </button>
  );
}
